import React, { createContext, useContext } from "react";

export type DashboardMode = "editor" | "viewer";

interface WebDashboardViewerContextValue {
  dashboardMode: DashboardMode;
  setDashboardMode: (mode: DashboardMode) => void;
  dashboardId: string;
  dashboardName?: string;
  spreadsheetId: string;
  slicerNames?: string[];
  isAiThinking: boolean;
  setIsAiThinking: (isThinking: boolean) => void;
  /** Archived dashboards are read-only: per-block triple-dot menus are hidden. */
  isArchived: boolean;
}

export const WebDashboardViewerContext = createContext<WebDashboardViewerContextValue | null>(null);

export const useWebDashboardViewerContext = (): WebDashboardViewerContextValue => {
  const context = useContext(WebDashboardViewerContext);
  if (!context) {
    throw new Error(
      "useWebDashboardViewerContext must be used within a WebDashboardViewerContext.Provider"
    );
  }
  return context;
};
